import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { isNilOrEmpty } from 'packages/core'
import MUIDateTimePicker from 'packages/eid-ui/DateTimePickers/MUIDateTimePicker/MUIDateTimePicker'
import { isDateInPast } from 'utils'
export const FulfillmentDateTimePicker = ({
    selectedFulfillmentDate,
    setSelectedFulfillmentDate,
    showWarningColor = false,
}) => {
    const { t } = useTranslation()
    return (
        <MUIDateTimePicker
            minDate={moment(new Date())}
            value={
                selectedFulfillmentDate
                    ? isDateInPast(selectedFulfillmentDate)
                        ? moment(new Date())
                        : moment(selectedFulfillmentDate)
                    : null
            }
            handleChange={(e) => {
                if (isNilOrEmpty(e)) {
                    setSelectedFulfillmentDate(moment().utc().format())
                } else {
                    const date = moment(e)
                    const dateToSet = date.clone().utc().format()
                    setSelectedFulfillmentDate(dateToSet)
                }
            }}
            label={t('SelectDate')}
            showWarningColor={showWarningColor}
        />
    )
}